var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-area",staticStyle:{"overflow":"hidden"}},[(_vm.isLogin)?_c('Info'):(_vm.$store.state.isWaitLogout)?_c('div',{staticClass:"is-logout"},[_c('i',{staticClass:"icon-loading"}),_vm._v(" "),_c('p',[_vm._v("登出中，请稍候")])]):_c('Login',{on:{"show":_vm.reportShow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }